import endpoints from "../utils/endpoints";
import { removeEmpty } from "../utils/objectUtils";
import { Api } from "./api";
import { notificationError, notificationSucces } from "./notification";

export async function getPulltabGamesList(params?: any){
    let res = {
      count: 0,
      page: null,
      perpage: 0,
      list: [],
    };
    
    if(params) {
      params = removeEmpty(params)
    }
    
    await Api.get(endpoints.getPulltabGames, {params}).then((response) => {
      res = response.data
    }).catch((err: string) => {
      notificationError('Could not get pull-tab games list')
    })
    
    return res
}

export async function getPulltabGameSettings(params?: any){
    let res = {
        title: '',
        form: '',
        wager: '',
        autoLoad: 'false',
        autoClose: 'false',
        autoCloseLimit: "",
        gameAvailableStartSetting: 'false',
        gameAvailableStart: '',
        gameAvailableEndSetting: 'false',
        gameAvailableEnd: ''
    };
    if(params) {
      params = removeEmpty(params)
    }
    await Api.get(endpoints.getPulltabGameById, {params}).then((response) => {
      res = response.data
    }).catch((err: string) => {
      notificationError('Could not get pull-tab game settings')
    })
    return res
}

export async function updateGameSettings(payload: any) {
    await Api.post(endpoints.updateGameSettings, payload).then((response) => {
      if(response.status === 200) {
          if(response.data.error) {
              notificationError(`${response.data.message}`)
          } else {
              notificationSucces('Settings updated successfully')
          }
      } else {
          notificationError(`${response.status}`)
      }
    }).catch((err: string) => {
      notificationError('Could not update settings')
    })
  }

export async function getPulltabGameFlare(params?: any){
    let res = {
        "0": 0
    }

    if(params) {
      params = removeEmpty(params)
    }
    await Api.get(endpoints.getPulltabGameFlare, {params}).then((response) => {
      res = response.data
    }).catch((err: string) => {
      notificationError('Could not get pull-tab game flare')
    })
    return res
}



export async function deleteGameById(params: any){
    let res = false
    await Api.get(endpoints.deleteGameById, {params}).then((response) => {
      if(response.status === 200) {
          if(response.data.error) {
              notificationError(`${response.data.message}`)
          } else {
              res = true
              notificationSucces('Game deleted successfully')
          }
      }
    }).catch((err: string) => {
        notificationError('Could not delete the game')
    })
    return res
}



export async function uploadGame(files?: any){
    let res = false
    let formData = new FormData()
    formData.append('files', files)
    await Api.post(endpoints.uploadGame, formData, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then((response) => {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        res = response.data.return
        notificationSucces(response.data.message)
      }
  
    }).catch((err: string) => {
      notificationError('Could not upload game')
    })
    return res
}

export async function uploadBingoGame(file?: any){
    let res = false
    let formData = new FormData()
    formData.append('file', file)
    await Api.post(endpoints.uploadBingoGame, formData, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then((response) => {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        res = response.data.return
        notificationSucces(response.data.message)
      }
  
    }).catch((err: string) => {
      notificationError('Could not upload game')
    })
    return res
}
